/**
 * Prefix for all stats metrics (count and time).
 */
export const STATS_PREFIX = 'services.layout_server';

/**
 * Prefix for all in memory size metrics.
 */
export const DATA_SIZE = 'data_size';
